var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1892 5.16512L9.22203 4.58856L7.44859 0.993249C7.40015 0.894812 7.32046 0.815124 7.22203 0.766687C6.97515 0.644812 6.67515 0.746374 6.55171 0.993249L4.77828 4.58856L0.811089 5.16512C0.701714 5.18075 0.601714 5.23231 0.525151 5.31044C0.432592 5.40557 0.381587 5.53356 0.383345 5.66628C0.385103 5.79901 0.439479 5.9256 0.534526 6.01825L3.40484 8.81669L2.72671 12.7682C2.71081 12.8602 2.72098 12.9547 2.75608 13.0411C2.79117 13.1276 2.84978 13.2025 2.92526 13.2573C3.00074 13.3121 3.09007 13.3447 3.18312 13.3513C3.27617 13.3579 3.36922 13.3384 3.45171 13.2948L7.00015 11.4292L10.5486 13.2948C10.6455 13.3464 10.758 13.3636 10.8658 13.3448C11.1377 13.2979 11.3205 13.0401 11.2736 12.7682L10.5955 8.81669L13.4658 6.01825C13.5439 5.94169 13.5955 5.84169 13.6111 5.73231C13.6533 5.45887 13.4627 5.20575 13.1892 5.16512Z",
    fill: "#FEA250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.44346e336f7ef3f75e50a50ea6f9ebd1.svg";
export { ForwardRef as ReactComponent };